(ns frontend.view.onboarding.initialize-account.events
  (:require [frontend.view.onboarding.initialize-account.db :as db]
            [frontend.actions.onboarding :as onboarding-actions]
            [frontend.logging :as logging]))

(defn update! [kw val]
  (if (nil? val)
    (swap! db/state dissoc kw)
    (swap! db/state assoc kw val)))

(defn toggle-set [s val]
  (set (if (contains? s val)
         (disj s val)
         (conj s val))))

(defn update-multi! [kw val]
  (swap! db/state update kw toggle-set val))

(defn initialize-account! []
  (let [team-role (-> @db/state :team-role)
        additional-responsibilities (-> @db/state :additional-responsibilities)
        data (cond-> {:onboarding/team-role team-role}
                     (seq additional-responsibilities)
                     (assoc :onboarding/additional-responsibilities additional-responsibilities))
        on-success! identity
        on-error! (fn [e]
                    (logging/error "failed to initialize account" e))]
    (onboarding-actions/*->initialize-account data
                                              on-success!
                                              on-error!)))

